import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";

function SideMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  // Redirect if the user is a Trainer and on the "/" route
  useEffect(() => {
    if (authContext.userType === "Trainer" && location.pathname === "/") {
      navigate("/batches");
    } else if (authContext.userType === "HR" && location.pathname === "/") {
      navigate("/employee");
    }
  }, [authContext.userType, location.pathname, navigate]);

  const menuItems = [
    { path: "/", label: "Dashboard", type: "All" },
    { path: "/users", label: "Users", type: "Superadmin" },
    { path: "/centre", label: "Training Centres", type: "Superadmin" },
    { path: "/scheme", label: "Scheme", type: "Superadmin" },
    { path: "/courses", label: "Courses", type: "All" },
    { path: "/trainer", label: "Trainers", type: "All" },
    { path: "/batches", label: "Batches", type: "All" },
    { path: "/students", label: "Students", type: "All" },
    { path: "/sanction", label: "Sanction Order", type: "All" },
    { path: "/invoice", label: "Invoice", type: "All" },
    { path: "/ledger", label: "Ledger", type: "All" },
    { path: "/employee", label: "Employee", type: "HR" },
    {path:"/reports",label:"Reports", type:"All"}
  ];

  const renderMenuItems = () => {
    return menuItems.map((item, index) => {
      // Determine if the menu item should be displayed based on userType
      if (
        (authContext.userType === "Accounts" && !(item.path === "/" || item.path === "/invoice" || item.path === "/ledger"||item.path==="/centre"||item.path==='/batches'||item.path==='/reports')) ||
        (item.type === "Superadmin" && authContext.userType !== "Superadmin" && authContext.userType !== "Manager") && authContext.userType!=='Accounts' ||
        (authContext.userType === "Trainer" && item.path !== "/batches") ||
        (authContext.userType === "HR" && item.path !== "/employee") ||
        (authContext.userType === "Manager" && (item.path === "/employee" || item.path === "/ledger" || item.path === "/invoice") && !(item.path === "/users" || item.path === "/centre" || item.path === "/scheme"||item.path==='/reports')) ||
        (authContext.userType === "Admin" && (item.path === "/employee"||item.path === "/ledger"||item.path === "/invoice"||item.path==="/reports")) // Exclude 'Employee' for Admin
      ) {
        return null; // Skip menu items that are not allowed for the current user
      }

      // Determine if the current path matches the menu item's path
      const isActive = location.pathname === item.path;

      return (
        <Link
          key={index}
          to={item.path}
          className={`flex cursor-pointer items-center justify-between rounded-lg px-4 py-2 text-gray-700 ${isActive ? 'bg-gray-700 text-white' : 'hover:bg-slate-200 hover:text-blue-800'}`}
        >
          <span className="text-md font-medium">{item.label}</span>
        </Link>
      );
    });
  };

  return (
    <div className="h-full flex-col justify-between scroll-smooth bg-white hidden overflow-y-auto lg:flex w-96">
      <div className="px-3 py-5">
        <nav aria-label="Main Nav" className="mt-5 flex flex-col">
          {renderMenuItems()}
        </nav>
      </div>
    </div>
  );
}

export default SideMenu;
